var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Page',{attrs:{"title":"In-Store Rewards","doc":_vm.doc},scopedSlots:_vm._u([{key:"header",fn:function(){return [_c('CreateForm')]},proxy:true}])},[_c('List')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }